import { useQuery } from '@tanstack/react-query'
import { fetchThreads, isThreadsApiAvailable } from '@/services/chat/threadsApi'
import { useWorkspaceStore } from '@/store/workspaceStore'
import { queryKeys } from '@/query/queryKeys'

export function useThreadsSearchListQuery({ workspaceScope, facet, q, enabled }) {
  const workspaceId = useWorkspaceStore((s) => s.activeWorkspaceId)
  const query = useQuery({
    queryKey: queryKeys.conversations.search({ workspaceId, workspaceScope, facet, q }),
    queryFn: ({ signal }) => fetchThreads({ signal, workspaceId, workspaceScope, facet, q }),
    enabled: Boolean(enabled && workspaceId && isThreadsApiAvailable()),
    staleTime: 0,
    refetchOnMount: 'always',
    placeholderData: (previous) => previous,
  })
  return { threads: query.data ?? [], loading: query.isPending && !query.data }
}
